import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";

export interface IUsersManagementFormMeta {
  firstName: FormInputMeta,
  lastName: FormInputMeta,
  position: FormInputMeta,
  birthDate: FormInputMeta,
  birthPlace: FormInputMeta,
  sex: FormInputMeta,
  contact: FormInputMeta,
  country: FormInputMeta,
  phone: FormInputMeta,
  email: FormInputMeta,
  username: FormInputMeta,
  password: FormInputMeta,
  confirmPassword: FormInputMeta,
  roles: FormInputMeta,
  
  schema: any,
}

const UsersMangementFormMeta: IUsersManagementFormMeta = {} as IUsersManagementFormMeta;

UsersMangementFormMeta.firstName = {
  label: 'Prénom',
  name: 'firstName',
  type: 'text',
  placeholder: 'Prénom',
  validation: yup.string().required(),
}

UsersMangementFormMeta.lastName = {
  label: 'Nom',
  name: 'lastName',
  type: 'text',
  placeholder: 'Nom',
  validation: yup.string().required(),
}


UsersMangementFormMeta.position = {
  label: 'Position/Fonction',
  name: 'position',
  type: 'text',
  placeholder: 'Position/Fonction',
  validation: yup.string().required(),
}

UsersMangementFormMeta.birthDate = {
  label: 'Date de naissance',
  name: 'birthDate',
  type: 'date',
  validation: yup.string().required(),
}

UsersMangementFormMeta.birthPlace = {
  label: 'Lieu de naissance',
  name: 'birthPlace',
  type: 'text',
  placeholder: 'Lieu de naissance',
  validation: yup.string().required(),
}

UsersMangementFormMeta.sex = {
  label: 'Sexe',
  name: 'sex',
  type: 'select',
  placeholder: 'Prénom',
  options:  [
    {
      label: 'Homme',
      value: 'man'
    },
    {
      label: 'Femme',
      value: 'woman',
    },
  ],
  validation: yup.string().required(),
}

UsersMangementFormMeta.country = {
  label: 'Pays de résidence',
  name: 'country',
  type: 'text',
  placeholder: 'Play de résidence',
  validation: yup.string().required(),
}

UsersMangementFormMeta.phone = {
  label: 'Téléphone',
  name: 'phone',
  type: 'text',
  placeholder: 'Téléphone',
  validation: yup.string().required(),
}

UsersMangementFormMeta.username = {
  label: "Nom d'utilisateur",
  name: 'username',
  type: 'text',
  placeholder: "Nom d'utilisateur",
  validation: yup.string().required(),
}

UsersMangementFormMeta.password = {
  label: 'Mot de passe',
  name: 'password',
  type: 'password',
  placeholder: 'Mot de passe',
  validation: yup.string().required(),
}

UsersMangementFormMeta.confirmPassword = {
  label: 'Confirmation du mot de passe',
  name: 'confirmPassword',
  type: 'text',
  placeholder: 'confirmation',
  validation: yup.string().required(),
}

UsersMangementFormMeta.roles = {
  label: 'Roles',
  name: 'roles',
  type: 'text',
  placeholder: 'Séléctionner les roles',
  validation: yup.string().required(),
}

UsersMangementFormMeta.email = {
  label: 'Adresse Email',
  name: 'email',
  type: 'email',
  placeholder: 'Addresse Email',
  validation: yup.string().required(),
}

const validationSchema: any = {};

for (let fieldname in UsersMangementFormMeta) {
  validationSchema[fieldname] = (UsersMangementFormMeta as any)[fieldname].validation;
}

// console.log('UsersManagement validation: ', validationSchema);

UsersMangementFormMeta.schema = yup.object().shape(validationSchema);

export default UsersMangementFormMeta;